 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		7: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"faf982d37fe5ec0101a14952969f6fb6407c39a0","1":"518e6421012d1ff3722832c8d56a474157d9e021","2":"943c0d5494292b97a917d224bfb63c7d68e6ffcb","3":"5c23263dddf062d34ac52a8abf9edef37b8d1191","4":"8c0d8845c39b9fc8a6e4e2454b05899e8645452d","5":"f327ec71549ff14f6d6f108d57320fccb1ed1475","6":"styles","12":"component---src-pages-about-js","13":"component---src-pages-academy-elearning-js","14":"component---src-pages-academy-js","15":"component---src-pages-admin-audit-js","16":"component---src-pages-admin-js","17":"component---src-pages-admin-projects-js","18":"component---src-pages-agency-1-js","19":"component---src-pages-agency-2-js","20":"component---src-pages-career-path-js","21":"component---src-pages-contact-js","22":"component---src-pages-designer-2-js","23":"component---src-pages-devloper-1-js","24":"component---src-pages-devloper-2-js","25":"component---src-pages-examples-js","26":"component---src-pages-grid-2-js","27":"component---src-pages-grid-3-fluid-js","28":"component---src-pages-grid-3-js","29":"component---src-pages-grid-4-fluid-js","30":"component---src-pages-grid-4-js","31":"component---src-pages-how-we-work-js","32":"component---src-pages-index-js","33":"component---src-pages-infrastructure-js","34":"component---src-pages-lab-js","35":"component---src-pages-labs-js","36":"component---src-pages-login-js","37":"component---src-pages-masonry-2-column-js","38":"component---src-pages-masonry-3-column-fluid-js","39":"component---src-pages-masonry-3-column-js","40":"component---src-pages-masonry-4-column-fluid-js","41":"component---src-pages-masonry-4-column-js","42":"component---src-pages-newsletter-js","43":"component---src-pages-notifications-js","44":"component---src-pages-p-js","45":"component---src-pages-patterns-js","46":"component---src-pages-photography-1-js","47":"component---src-pages-photography-2-js","48":"component---src-pages-portfolio-details-2-js","49":"component---src-pages-portfolio-details-js","50":"component---src-pages-pricing-js","51":"component---src-pages-profile-js","52":"component---src-pages-proposal-js","53":"component---src-pages-sales-dashboard-js","54":"component---src-pages-sales-js","55":"component---src-pages-sales-leads-js","56":"component---src-pages-slack-js","57":"component---src-pages-staffing-js","58":"component---src-pages-team-js","59":"component---src-pages-time-tracker-js","60":"component---src-pages-tools-js","61":"component---src-pages-unsubscribe-js","62":"component---src-templates-elearning-module-js","63":"component---src-templates-opening-detail-js","64":"component---src-templates-pattern-detail-js","67":"reactPlayerDailyMotion","68":"reactPlayerFacebook","69":"reactPlayerFilePlayer","70":"reactPlayerKaltura","71":"reactPlayerMixcloud","72":"reactPlayerPreview","73":"reactPlayerSoundCloud","74":"reactPlayerStreamable","75":"reactPlayerTwitch","76":"reactPlayerVidyard","77":"reactPlayerVimeo","78":"reactPlayerWistia","79":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"7c3cd136fb416136dab8","1":"2f933bc7abea8089818a","2":"fff151f9b6772b75936a","3":"9cf7f4592ed95055bc5a","4":"8d649762ad93bdef7841","5":"d4d4262119874915157c","6":"001ae6ded9fe131102a4","12":"8e7abe68366e83ef8fc4","13":"c273117e144b1af18adf","14":"08288fae12c1e6b3bd78","15":"32d4584e7d9fefa4fa63","16":"7ef44250781a9ea12af4","17":"74ad2ea020902deb6868","18":"c1e758cba6fb2468512a","19":"2b2ebd7cd224bad5e059","20":"49e54d733eabd82371e7","21":"cfeaa79e47e5a5c40436","22":"f73d7e3bdf65ec7e1433","23":"4ba24033e83ddfa96f73","24":"639d6ce893ef6ad40d85","25":"10de375977a2a37a4f31","26":"b27a9003066876d6edd3","27":"718e1b0f11bd6e2769ba","28":"0e765ecad95c5fa2beac","29":"65ddbae2f034bd67499c","30":"b8443babe9bd2b4653fd","31":"e2cc56c55cab4d828c43","32":"639c89a4d3c71c8ad6b3","33":"0054a287c1bd24913f02","34":"3f115c4c263b8abb30dd","35":"8f0e38e4163ab81bf530","36":"7adaad62b3d66432f02f","37":"1439803c12f30e5da6a7","38":"95163b7d6f456768311f","39":"b81bdd8bb0b9bdb7beb0","40":"18c644468a7ad7faa51f","41":"fdd9b8108bc6661830ef","42":"d246ef2bee7ee8d16684","43":"129e2a8d392599241479","44":"de6fc185a55e419e1c53","45":"9e49e7c1f3fefee932e2","46":"cb95a1ed46fcf5a92da1","47":"eb30a76cd0e311199a14","48":"91fb91aa3521032b1bfa","49":"07efaa17e9914f44f275","50":"a2638beeb2038b6506b9","51":"4c86f50d3813729618d5","52":"10bb86db5e29f41a2537","53":"02aad83a3fe265b0fec9","54":"87df87ff6a67434d1f89","55":"bb3c5f8868b83c4b8f52","56":"0b0f4e44e2d4522944b0","57":"ddcb66a1427812f74e5c","58":"60eb76cded756d5539d2","59":"b43dad3e8fd17453a642","60":"3d8304fb7411f5dc9157","61":"4c9cdd136bc41f79d12e","62":"f2d4cb76158240a9e0f5","63":"5339f65b36574ba783d1","64":"ebb9caa25b3b18c83ffc","67":"09813350bab38fcc9558","68":"91c8b039404da909836f","69":"09403af306cfa27b79c8","70":"6a9cd90a3c7fdf77773b","71":"cfe9a2cefbc2f1b88029","72":"67b7ca53d3de99832376","73":"159de0fe6fbd3a1441f5","74":"7fda9a2ffadf776efc45","75":"95b9a551cdc0353638f2","76":"6fa904b56fe9d7a4f656","77":"e3dec9f3d10a440fba4a","78":"b3a4043545c9bc6f127d","79":"fc4f1798a29eecdf9cfe","80":"671b3438c387f6cb4a15","81":"bff696415987bd0a6d6a","82":"a963ce55b1e17ced5d80","83":"c6755590d551f9c42263","84":"f6ba5c4d7bff6cc7c648","85":"927e90ff3d8fb45e808f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"6":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"faf982d37fe5ec0101a14952969f6fb6407c39a0","1":"518e6421012d1ff3722832c8d56a474157d9e021","2":"943c0d5494292b97a917d224bfb63c7d68e6ffcb","3":"5c23263dddf062d34ac52a8abf9edef37b8d1191","4":"8c0d8845c39b9fc8a6e4e2454b05899e8645452d","5":"f327ec71549ff14f6d6f108d57320fccb1ed1475","6":"styles","12":"component---src-pages-about-js","13":"component---src-pages-academy-elearning-js","14":"component---src-pages-academy-js","15":"component---src-pages-admin-audit-js","16":"component---src-pages-admin-js","17":"component---src-pages-admin-projects-js","18":"component---src-pages-agency-1-js","19":"component---src-pages-agency-2-js","20":"component---src-pages-career-path-js","21":"component---src-pages-contact-js","22":"component---src-pages-designer-2-js","23":"component---src-pages-devloper-1-js","24":"component---src-pages-devloper-2-js","25":"component---src-pages-examples-js","26":"component---src-pages-grid-2-js","27":"component---src-pages-grid-3-fluid-js","28":"component---src-pages-grid-3-js","29":"component---src-pages-grid-4-fluid-js","30":"component---src-pages-grid-4-js","31":"component---src-pages-how-we-work-js","32":"component---src-pages-index-js","33":"component---src-pages-infrastructure-js","34":"component---src-pages-lab-js","35":"component---src-pages-labs-js","36":"component---src-pages-login-js","37":"component---src-pages-masonry-2-column-js","38":"component---src-pages-masonry-3-column-fluid-js","39":"component---src-pages-masonry-3-column-js","40":"component---src-pages-masonry-4-column-fluid-js","41":"component---src-pages-masonry-4-column-js","42":"component---src-pages-newsletter-js","43":"component---src-pages-notifications-js","44":"component---src-pages-p-js","45":"component---src-pages-patterns-js","46":"component---src-pages-photography-1-js","47":"component---src-pages-photography-2-js","48":"component---src-pages-portfolio-details-2-js","49":"component---src-pages-portfolio-details-js","50":"component---src-pages-pricing-js","51":"component---src-pages-profile-js","52":"component---src-pages-proposal-js","53":"component---src-pages-sales-dashboard-js","54":"component---src-pages-sales-js","55":"component---src-pages-sales-leads-js","56":"component---src-pages-slack-js","57":"component---src-pages-staffing-js","58":"component---src-pages-team-js","59":"component---src-pages-time-tracker-js","60":"component---src-pages-tools-js","61":"component---src-pages-unsubscribe-js","62":"component---src-templates-elearning-module-js","63":"component---src-templates-opening-detail-js","64":"component---src-templates-pattern-detail-js","67":"reactPlayerDailyMotion","68":"reactPlayerFacebook","69":"reactPlayerFilePlayer","70":"reactPlayerKaltura","71":"reactPlayerMixcloud","72":"reactPlayerPreview","73":"reactPlayerSoundCloud","74":"reactPlayerStreamable","75":"reactPlayerTwitch","76":"reactPlayerVidyard","77":"reactPlayerVimeo","78":"reactPlayerWistia","79":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"d93bb23495ae68b4f7e6","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c","85":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
